import { TEXTOS } from '../../manual-textos';
import { itensValidos, ou } from '../../manual-utils';
import {
  blocoCapitulo,
  blocoImagem,
  blocoLista,
  blocoSecao,
  blocoTabela,
  blocoTexto,
} from '../blocos';
import { etapasParaTabela } from './comuns';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';

export function capitulo5(dados: ManualData): Bloco[] {
  const blocos: Bloco[] = [blocoCapitulo(5, 'Operação')];

  blocos.push(blocoSecao('5.1', 'Apresentação geral'));
  blocos.push(...blocoTexto(dados.apresentacaoOperacao || TEXTOS.operacaoIntro, 'c5-apresentacao'));

  const comandos = itensValidos(dados.comandos, ['identificacao', 'funcao', 'tipo']);
  if (dados.imagemComandos) {
    // Os pontos da figura são os mesmos números da coluna IDENTIFICAÇÃO.
    const marcadores = dados.comandos
      .filter((item) => typeof item.x === 'number' && typeof item.y === 'number')
      .map((item) => ({ numero: item.identificacao || '?', x: item.x as number, y: item.y as number, lx: item.lx, ly: item.ly }));
    blocos.push(...blocoImagem({
      id: 'c5-comandos-figura',
      titulo: 'COMANDOS, INDICADORES E DISPOSITIVOS',
      imagem: dados.imagemComandos,
      legenda: marcadores.length ? 'Os pontos numerados correspondem à coluna IDENTIFICAÇÃO da tabela a seguir.' : undefined,
      marcadores,
      altura: 260,
    }));
  }
  blocos.push(...blocoTabela({
    id: 'c5-comandos',
    legenda: 'COMANDOS, INDICADORES E DISPOSITIVOS',
    colunas: ['IDENTIFICAÇÃO', 'TIPO', 'FUNÇÃO', 'LOCALIZAÇÃO'],
    linhas: comandos.map((item) => [ou(item.identificacao, '—'), ou(item.tipo, '—'), ou(item.funcao, '—'), ou(item.local, '—')]),
    larguras: ['22%', '18%', '36%', '24%'],
    alinharEsquerda: true,
    porPagina: 16,
  }));

  blocos.push(blocoSecao('5.2', 'Preparação'));
  blocos.push(...etapasParaTabela(dados.preparacao, 'c5-preparacao', 'SEQUÊNCIA DE PREPARAÇÃO'));

  blocos.push(blocoSecao('5.3', 'Operação'));
  blocos.push(...etapasParaTabela(dados.operacao, 'c5-operacao', 'SEQUÊNCIA DE OPERAÇÃO'));

  blocos.push(blocoSecao('5.4', 'Parada normal'));
  blocos.push(...etapasParaTabela(dados.parada, 'c5-parada', 'SEQUÊNCIA DE PARADA'));

  blocos.push(blocoSecao('5.5', 'Emergência'));
  blocos.push(...blocoTexto(TEXTOS.emergenciaOperacao, 'c5-emergencia-intro'));
  blocos.push(...etapasParaTabela(dados.emergenciaEtapas, 'c5-emergencia', 'ATUAÇÃO EM EMERGÊNCIA'));

  if (dados.opcoes.incluirUsoImprevisivel) {
    blocos.push(blocoSecao('5.6', 'Mau uso razoavelmente previsível'));
    blocos.push(...blocoTexto(TEXTOS.usoImprevisivelIntro, 'c5-imprevisivel-intro'));
    blocos.push(...blocoLista(itensValidos(dados.usosImprevisiveis, ['texto']).map((item) => item.texto), 'c5-imprevisivel'));
  }

  return blocos;
}
